import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center -mt-10 mb-x4 md:mb-x6" }
const _hoisted_2 = { class: "o-scrollbar-y scroll-container px-x3 sm:px-x4" }

import BaseDialog from '@/shared/dialog/BaseDialog.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomizerOverlay',
  props: {
    isOpen: { type: Boolean },
    title: { default: undefined }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDialog, {
    "is-open": __props.isOpen,
    class: "fixed inset-0 py-x4 mx-auto z-1 bg-white max-w-1200 pt-60 flex flex-col sm:relative sm:inset-auto sm:w-screen-90 sm:h-auto sm:w-screen-80 sm:max-h-screen-90",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("h3", _hoisted_1, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["is-open"]))
}
}

})